import { cva } from "class-variance-authority";

export const fieldLabelClassname = "mb-8 tw-text-xs md:tw-text-sm tw-text-black tw-cursor-default";

export const fieldInputVariants = cva(
  [
    "w-full tw-rounded-xl tw-border tw-border-gray-200 tw-px-4 tw-py-3",
    "tw-text-xs md:tw-text-base tw-text-black placeholder:tw-text-gray-400",
    "focus:tw-outline-none focus:tw-border-black",
  ],
  {
    variants: {
      type: {
        input: "tw-max-h-11",
        textarea: "tw-min-h-[7.5rem]",
      },
    },
    defaultVariants: {
      type: "input",
    },
  },
);

export const selectTriggerClassname =
  "inline-flex w-full tw-max-h-11 items-center justify-between tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-px-4 tw-py-3 " +
  "tw-text-xs md:tw-text-base tw-text-black " +
  "focus:tw-outline-none focus:tw-border-black " +
  "disabled:tw-cursor-not-allowed disabled:tw-opacity-50 ";

export const selectContentClassname =
  "relative tw-z-50 tw-rounded-xl tw-border border-default tw-bg-white tw-p-1 tw-shadow-lg";

export const selectItemClassname =
  "relative tw-flex tw-h-9 w-full tw-cursor-pointer tw-items-center tw-px-3 tw-outline-none " +
  "tw-text-xs md:tw-text-base tw-text-black";

export const fieldErrorClassname = "text-negative tw-text-sm mt-2 tw-cursor-default";
